import styled from "styled-components";

export const GridBaseBox = styled.div`
    display: grid;
    grid-template-columns: auto 1fr auto;
    width: 100%;
`